import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["day", "panel", "empty", "emptyDate"];

  select(event) {
    const selectedDay = event.currentTarget;
    const date = selectedDay.dataset.date;

    this.dayTargets.forEach((day) => {
      day.setAttribute("aria-pressed", String(day === selectedDay));
    });

    let found = false;
    this.panelTargets.forEach((panel) => {
      const selected = panel.dataset.date === date;
      panel.hidden = !selected;
      panel.classList.toggle("hidden", !selected);
      found ||= selected;
    });

    this.emptyTarget.hidden = found;
    this.emptyTarget.classList.toggle("hidden", found);
    if (!found)
      this.emptyDateTarget.textContent = `${selectedDay.dataset.dateLabel}没有打卡`;
  }
}
